import React from 'react'
import img from './Images/about.png'
import img1 from './Images/Ready.png'

const About = () => {
  return (
    <>
        <div className="about">
            <img src={img} alt="" className='banneer'/>

                    <h1>Hi</h1>
            <div className="flex">
                <div className="col">
                    <h3>I'm Micheal.A.Nwankwo</h3>
                    <p>
                        I am a graduate of Lagos State University of Education with 
                        a degree in Computer Science.
                        My journey in the world of design and technology began during 
                        my school years when I 
                        worked as a graphic designer. 
                        Three years after graduation, I made a career shift to become 
                        a UI/UX designer, recognizing my passion 
                        and potential in this creative field.
                    </p>
                    <p>
                        However, my true calling emerged when I ventured into the 
                        exciting realms of Gaming and 
                        XR (Extended Reality). I 
                        transitioned into a full-time XR developer, combining my design
                        expertise with scripting skills. My unique blend of design acumen, 
                        research capabilities,
                        intuition, and scripting proficiency has 
                        enabled me to excel in this dynamic and innovative 
                        field. I am dedicated to pushing the boundaries of XR
                        technology and creating immersive 
                        experiences that captivate audiences worldwide.
                    </p>
                </div>
                <img src={img1} alt="" className='img'/>
            </div>
        </div>
    </>
  )
}

export default About